import gql from 'graphql-tag';

export const applicationTypeQuery = gql`
  query ApplicationTypeQuery($companyProfileId: ID!) {
    viewer {
      uid
      company: application(companyProfileId: $companyProfileId) {
        applicationId
        companyProfileId
        isCapitalDeposit
        isShineStart
        capitalDeposit {
          capitalDepositId
          partner
          isConfirmedPartner
          updatedAt
        }
        shineStart {
          shineStartId
        }
      }
    }
  }
`;
